import { useRef } from "react";
import { 
	AlertDialog,
	AlertDialogBody,
	AlertDialogCloseButton,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Button,
} from "@chakra-ui/react";
import { useCart } from "../../hooks/cart";
import { useHistory } from "react-router-dom";

interface AlertCancelPedidoParams {
	isOpen: boolean;
	onRequestClose: (close: boolean) => void;
};

const AlertCancelPedido: React.FC<AlertCancelPedidoParams> = ({
	isOpen,
	onRequestClose,
}) => {
	const cancelRef = useRef<any>(null);
	const { initCart } = useCart();
	const history = useHistory();

	return (
		<AlertDialog
			motionPreset='slideInBottom'
			size="sm"
			leastDestructiveRef={cancelRef}
			onClose={() => onRequestClose(false)}
			isOpen={isOpen}
			isCentered
		>
			<AlertDialogOverlay />

			<AlertDialogContent mx={["2", ""]}>
				<AlertDialogHeader>Descartar Pedido?</AlertDialogHeader>

				<AlertDialogCloseButton />

				<AlertDialogBody>
					Você deseja mesmo cancelar este pedido?
				</AlertDialogBody>
				<AlertDialogFooter>
					<Button
						colorScheme="blackAlpha"
						ref={cancelRef}
						onClick={() => onRequestClose(false)}
					>
						Não
					</Button>

					<Button 
						colorScheme="red"
						ml={3}
						onClick={() => {
							initCart();
							history.push('/client');
						}}
					>
						Sim
					</Button>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}

export default AlertCancelPedido;